import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueI18n from 'vue-i18n';
import "@/theming/custom.scss";
import { defaultLocale, messages } from "./i18n/setup";
import Vuelidate from 'vuelidate';

axios.defaults.baseURL = process.env.VUE_APP_APIURL + "/";

//BootstrapVue
Vue.use(BootstrapVue);
//Icon component plugin for above
Vue.use(IconsPlugin);

Vue.use(VueI18n);

Vue.use(Vuelidate);

export const i18n = new VueI18n({
  messages,
  locale: defaultLocale,
  fallbackLocale: defaultLocale
})

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
